<template>
    <div>
        <!-- Header -->
        <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-7">
            <div class="container">
                <div class="header-body text-center">
                    <div class="row justify-content-center">
                        <div class="col-xl-5 col-lg-6 col-md-8 px-5">
                            <h1 class="text-white">{{ $t('auth.completeRegistration') }}</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                     xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-3">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-7">
                    <div class="card card-profile bg-secondary mt-5">
                        <div class="card-body pt-5 px-5">
                            <form role="form">
                                <div class="form-group">
                                    <label
                                        for="language-selector"
                                        class="form-control-label">{{ $t('auth.language') }}
                                    </label>
                                    <select
                                        v-model="user.language"
                                        id="language-selector"
                                        class="form-control"
                                        @change="languageChanged">
                                        <option
                                            v-for="language in languages"
                                            :key="language.id"
                                            class="select-danger"
                                            :value="language.id"
                                            :label="language.name">
                                        </option>
                                    </select>
                                </div>

                                <base-input
                                    prepend-icon="ni ni-lock-circle-open"
                                    type="password"
                                    :label="$t('auth.password')"
                                    :placeholder="$t('auth.password')"
                                    name="password"
                                    v-model="user.password"
                                    autofocus
                                    v-validate="userValidations.password"
                                    :error="getError('password')"
                                    @keydown.enter="resetPassword"></base-input>

                                <base-input
                                    prepend-icon="ni ni-lock-circle-open"
                                    type="password"
                                    :label="$t('auth.confirmPassword')"
                                    :placeholder="$t('auth.confirmPassword')"
                                    name="confirm"
                                    v-model="user.confirmPassword"
                                    @keydown.enter="resetPassword"></base-input>
                                <PinInput2
                                        class="form-group"
                                        data-vv-name="pinCode"
                                        v-model="user.pinCode"
                                        :label="$t('forms.newPinCode')"
                                        :error="getError('pinCode')"
                                        v-validate="userValidations.pinCode"></PinInput2>

                                <div class="text-center">
                                    <base-button
                                        type="primary"
                                        class="mt-2"
                                        @click="submit">{{ $t("auth.complete") }}
                                    </base-button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import VeeValidateMixin from '@/mixins/vee-validate-mixin'
    import PinInput2 from "@/components/Inputs/PinInput2";

    export default {
        name: 'ForgotPassword',
        mixins: [VeeValidateMixin],
        components: {
            PinInput2
        },
        data() {
            return {
                languages: [],
                user: {
                    email: null,
                    password: '',
                    confirmPassword: '',
                    pinCode: '',
                    language: null,
                    token: '',
                },
                userValidations: {
                    password: {
                        required: true,
                        min: 5,
                    },
                    confirmPassword: {
                        required: true,
                        confirmed: 'password',
                    },
                    pinCode: {
                        required: false,
                        digits: 4,
                    },
                    language: {
                        required: true,
                        integer: true,
                    }
                }
            }
        },
        methods: {
            async submit(e) {
                e.preventDefault();

                const isValid = await this.$validator.validateAll();

                console.log(this.$validator.allErrors);

                console.log('VALIDATOR: ', isValid);

                if (isValid) {
                    this.$axios.post('/api/completeRegistration', this.user)
                        .then(() => {
                            this.$router.push('/login');
                        })
                        .catch(({response}) => {
                            this.$notify({
                                title: response.data.message,
                                type: 'danger',
                            });
                        })
                }
            },
            languageChanged(languageId) {
                const foundLang = this.languages.find(lang => lang.id === languageId);
                const lang = foundLang ? foundLang.code : 'en';
                this.$i18n.locale = lang;
                this.$cookies.set('lang', lang)
                document.querySelector('html').setAttribute('lang', lang)
            }
        },
        beforeCreate() {
            if (!this.$route.query.token) {
                this.$router.push('/login');
            }

            const docLang = document.documentElement.lang;
            const userLang = this.$cookies.get('lang');

            if (userLang) {
                this.$i18n.locale = userLang;
                document.querySelector('html').setAttribute('lang', userLang)
            } else if (docLang && Object.keys(this.$i18n.messages).includes(docLang)) {
                this.$i18n.locale = docLang;
                this.$cookies.set('lang', docLang);
            } else {
                this.$cookies.set('lang', 'en');
                document.querySelector('html').setAttribute('lang', 'en')
            }
        },
        mounted() {
            this.user.token = this.$route.query.token;

            this.$axios.get('/api/languages')
                .then(res => {
                    this.languages = res.data;
                    const docLang = document.documentElement.lang;
                    const userLang = this.$cookies.get('lang');
                    let defaultSelectedLang = this.languages.find(lang => lang.code === docLang);

                    if (userLang) {
                        defaultSelectedLang = this.languages.find(lang => lang.code === userLang);
                    } else if (!defaultSelectedLang) {
                        defaultSelectedLang = this.languages.find(lang => lang.is_default === 1);
                    }

                    this.user.language = defaultSelectedLang ? defaultSelectedLang.id : 1;
                })
                .catch(err => {
                    console.warn(err.response.data);
                });

            // this.$axios.get('/api/getUserEmailByToken?token=' + this.user.token)
            //     .then(res => {
            //         this.user.email = res.data;
            //     })
            //     .catch(err => {
            //         console.log(err);
            //     });
        },
    };
</script>

<style lang="scss">
    .failed-message {
        font-size: 13px;
        margin-top: -20px;
        margin-bottom: 20px;
    }
</style>
